<mat-card class="back">

    <form [formGroup]="resetPasswordFormGroup" class="example-form" (ngSubmit)="sendPasswordResetLink()">
        <span>
            <h3>Enter Email details</h3>
        </span><br>
        <div>
            <br>
            <mat-form-field class="example-full-width">
                <input matInput  formControlName="email" placeholder="Email Id" required>
            </mat-form-field>
            <br>
        </div>

        <div>
            <button  mat-raised-button color="primary" [disabled]="isLoading">Reset Password</button>
        </div>

    </form>

</mat-card>